import $ from 'jquery';
import './foundation.js';
import { responsiveEmbeds } from './responsive-embeds.js';
import { footerAccordion } from './footer-accordion.js';
import { gallerySlider } from './gallyer-slider.js';
import { connect } from './connect.js';
import { forms } from './forms.js';
import { Header } from './header.js';
import { VideoModal } from './video-modal.js';
import { animations } from './animations.js';
import { offCanvas } from './off-canvas.js';
import { InlineVideo } from './inline-video-row.js';
import { hero } from './hero.js';
import { footer } from './footer.js';

$(document).ready(function() {
	$(document).foundation();
	
	responsiveEmbeds();
	footerAccordion();
	gallerySlider();
	connect();
	forms();
	Header();
	VideoModal();
	animations();
	offCanvas();
	InlineVideo();
	hero();
	footer();
});

$('html').removeClass('no-js')	
				 .addClass('js');